<template>
    <div class="dept-data">
        <!--      <div class="dept-tit">Hi {{ userName }}</div>-->
        <!--      <div class="dept-tit">Hi {{ userName }}，{{ userdept }}</div>-->
        <div class="drop-inner">
            <div class="drop-inner-left">
                <div class="dept-drop-dept">

                    <van-dropdown-menu v-if="userLever.substring(0,1)=='M'">
                        <van-dropdown-item v-model="countDeptVal" :options="countDeptOption" @change="changeDept"/>
                    </van-dropdown-menu>
                    <div class="deptname" v-else>{{deptName}}</div>
                </div>

                <div class="sch-drop" v-if="isShow">
                    <span class="label" v-if="isShowUser">选择部门用户</span>
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="userMenuVal" :options="userOption" @change="changeUserMenu"/>
                    </van-dropdown-menu>
                    <div class="close" v-if="!isShowUser" @click="close">
                        <van-icon name="close"/>
                    </div>
                </div>
            </div>

            <div class="dept-drop">
                <van-dropdown-menu>
                    <van-dropdown-item v-model="countMenuVal" :options="countMenuOption" @change="changeMenu"/>
                </van-dropdown-menu>
            </div>
        </div>
        <div class="dept-inner">
            <div class="dept-total">
                <div class="count-hd">总预约量(次)</div>
                <div class="count"><span class="count-text">{{ deptCountTotal }}</span></div>
            </div>
            <div class="dept-total">
                <div class="count-hd">总预约时间(时)</div>
                <div class="time"><span class="count-time">{{ deptTimeTotal }}</span></div>
            </div>
        </div>

    </div>
</template>

<script>
    import common from "@/api/common";

    export default {
        name: "faeDataHeader",
        props: {
            deptCountTotal: Number,
            deptTimeTotal: Number,
        },
        data() {
            return {
                deptId: '',
                deptName: '',
                userLever: '',
                countMenuVal: 0,
                countMenuOption: [],

                isShow: false,
                isShowUser: true,
                userMenuVal: 0,  // 用户
                userOption: [],

                countDeptVal: 0,
                countDeptOption: [],
                duty: '', // 职务
                isBoss: false, // 当前用户是否是特殊权限的人群
            }
        },
        mounted() {
            this.caleAuthority()
            this.inincountMenuOption()
        },
        methods: {
            inincountMenuOption() {
                let currentWeek = this.Common.formatYearWeek(new Date());
                let temMenu = [
                    {text: this.Common.formatYear(new Date()) + '年', value: 0}
                ];

                if(currentWeek>6 &&  this.userLever.substring(0,1)=='M'){
                    let weekName = '六'
                    temMenu.push({text: '近' + weekName + '周', value: 2})
                }

                temMenu.push({text: '本月', value: 1})
                temMenu.push({text: '上周', value: 4})
                temMenu.push({text: '本周', value: 3})


                this.countMenuOption = temMenu;
            },
            caleAuthority() {
                let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'))
                this.deptId = ADMIN.USER_DEPARTMENT_ID;
                this.deptName = ADMIN.USER_DEPARTMENT_NAME;

                this.userLever = ADMIN.USER_LEVEL_NAME;
                this.countDeptVal = this.deptId;
                this.duty = ADMIN.DUTY_NAME;
                // 测试用
                // this.deptId = 985;
                // this.userName =  "刘迅";
                // this.userdept = "中电港";
                // this.userLever = "M5";
                // this.duty = '总经理';



                this.bosArrName = JSON.parse(localStorage.getItem('BOSS_NAME')) || [];
                let userName = JSON.parse(localStorage.getItem('LS_ADMIN')).USER_ACCOUNT; // 当前用户 英文名
                let dutyName = JSON.parse(localStorage.getItem('LS_ADMIN')).DUTY_NAME; // 当前用户 职位
                this.isBoss = this.bosArrName.includes(userName) || this.bosArrName.includes(dutyName);

                if(this.isBoss){
                    // alert(this.isBoss)
                    this.deptId = 985;
                    this.deptName = "中电港";
                    this.countDeptVal = this.deptId;
                    this.userLever = "M5"
                }

                // alert(this.deptName)

                //userLever.substring(0,1)=='M'
                if (this.userLever.substring(0, 1) == 'M') {
                    this.getDeptDatas()
                }
            },

            // 切换年份
            changeMenu(value) {
                this.$emit('changeMenu', value);
            },

            // 切换用户
            changeUserMenu(value) {
                this.isShowUser = false
                this.$emit('changeUserMenu', value);
            },

            close() {
                this.isShow = true;
                this.isShowUser = true;
                this.userMenuVal = 0;

                this.$emit('changeUserMenu', 0);
            },

            // 切换部门
            changeDept(value) {
                console.log(value)
                this.deptId = value;
                let params = {
                    id: value,
                    name: this.getDeptName(value)
                }
                this.isShow = true;
                this.isShowUser = true;
                this.userMenuVal = 0;
                this.getDeptPerson();

                this.$emit('changeDept', params);
            },

            getDeptName(value) {
                let $data = this.countDeptOption;
                let temt = ''
                if ($data.length > 0) {
                    this.countDeptOption.forEach(item => {
                        // console.log(item.value +'-' +value)
                        if (item.value == value) {
                            temt = item.text;
                            return
                        }
                    })
                    return temt
                }
            },

            // 根据部门获取部门人员名单
            getDeptPerson() {
                let params = {
                    pkg: "crm_fae_public_pkg",
                    pro: "p_get_user_by_dept",
                    DEPT_ID: this.deptId
                };
                common.procedureQuery(params).then(res => {
                    if (res && res.flag) {
                        this.userOption = this.formatUserMenu(res.data);
                    } else {
                        this.userOption = [];
                        // this.$toast("网络异常，请稍后再试！");
                    }
                })
            },

            // 根据当前人员部门id 获取子部门数据
            getDeptDatas() {
                let params = {
                    pkg: "crm_fae_public_pkg",
                    pro: "p_get_fae_dept",
                    DEPT_ID: this.deptId
                };
                common.procedureQuery(params).then(res => {
                    if (res && res.flag) {
                        this.countDeptOption = this.formatMenu(res.data);
                        console.log( this.countDeptOption)

                        if (this.countDeptOption.length == 1) {
                            this.isShow = true;
                            this.isShowUser = true;
                            this.userMenuVal = 0;
                            this.getDeptPerson();
                        }
                    } else {
                        this.isShow = false;
                        this.isShowUser = false;
                        // this.$toast("网络异常，请稍后再试！");
                    }
                })
            },
            /*getDeptDatas() {
              // {text: '产品二部', value: 0},
              // {text: '产品一部', value: 1}
              let entityId = this.CoreNew.SYSTABLE.DEPT
              let params = {PARENT_ID: this.deptId}
              common.generalConditionQuery(entityId, params).then(res => {
                if (res && res.flag && Array.isArray(res.data)) {
                  if (res.data.length > 0) {
                    this.countDeptOption = this.formatMenu(res.data);
                    // console.log(this.countDeptOption)
                    // console.log(this.countDeptVal)
                  }
                } else {
                  this.$toast("网络异常，请稍后再试！");
                }
              })
            },*/

            formatUserMenu(arr) {
                if (!arr || arr.length == 0) {
                    return
                }
                let temArr = [];
                arr.filter((item, index) => {
                    let temObj = {}
                    temObj.text = item.LABEL_NAME
                    temObj.value = item.ID;
                    temArr.push(temObj)
                })

                // console.log(temArr)
                return temArr;
            },

            formatMenu(arr) {
                if (!arr || arr.length == 0) {
                    return
                }
                // countDeptOption: [
                //   {text: '产品二部', value: 0},
                //   {text: '产品一部', value: 1}
                // ],

                let temArr = [
                    {
                        text: this.deptName,
                        value: this.deptId,
                        parentID: 0
                    }
                ];

                arr.filter((item, index) => {
                    let temObj = {}
                    if (item.ID != temArr[0].value) {
                        temObj.text = item.NAME
                        temObj.value = item.ID;
                        temArr.push(temObj)
                    }
                })

                // console.log(temArr)
                return temArr;
            },


        }
    }
</script>

<style scoped lang="less">
    //@import "../../../assets/css/base.less";

    .dept-data {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: @linearBlue;
        padding: 0 15px;
        color: #fff;

        .drop-inner {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            position: relative;
            width: 100%;
            border-bottom: 1px solid rgba(255, 255, 255, .1);
            margin-bottom: 10px;

            .drop-inner-left {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                flex: 1;

                .sch-drop {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 12px;
                    position: relative;


                    .label {
                        position: absolute;
                        right: 5px;
                    }

                    .close {
                        position: absolute;
                        right: -26px;
                        top: 0;
                        width: 20px;
                        height: 40px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 14px;

                        .van-icon {
                            margin-top: 2px;
                        }
                    }

                    /deep/ .van-dropdown-menu__title {
                        min-width: 90px;
                    }

                    /deep/ .van-ellipsis {
                        text-align: right;
                    }
                }
            }

        }

        .dept-drop-dept {
            .deptname {
                font-size: 12px;
            }
        }

        .dept-drop {

        }


        .dept-tit {
            font-size: 14px;
            margin-bottom: 20px;
            width: 100%;
            text-align: left;
        }

        .dept-inner {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 90%;
            padding: 10px 0;


            .dept-total {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .count-hd {
                    font-size: 12px;
                }

                .count-text, .count-time {
                    font-size: 30px;
                }
            }
        }

        /deep/ .van-dropdown-menu__bar {
            background: none;
            box-shadow: none;
            height: 42px;
        }

        /deep/ .van-dropdown-menu__item {
            justify-content: flex-start;
        }

        /deep/ .van-dropdown-menu__title {
            color: #fff;
        }

        /deep/ .van-dropdown-menu__title::after {
            border-color: transparent transparent #fff #fff;
        }

        /deep/ .van-dropdown-menu__title,
        /deep/ .van-cell__title {
            font-size: 12px;
        }

        /deep/ .van-dropdown-item__option--active .van-dropdown-item__icon,
        /deep/ .van-dropdown-item__option--active {
            color: #2196f3;
        }

        /deep/ .van-dropdown-menu__title--active {
            color: #fff;
        }
    }
</style>